export enum StorageKeys {
    PageNumber='PageNumber',
    PageSize='PageSize',
    Filters='FilteredData',
    SearchTerm='SearchTerm',
    SortColumn='SortColumn',
    Route='Route',
    EditCarrier='EditCarrier',
  }
  